export default __webpack_public_path__ + "static/media/arcaneabatement.caf35ab2.png";